// extracted by mini-css-extract-plugin
module.exports = {"darkBG":"modal_darkBG__oxivV","modal":"modal_modal__t6gBw","content":"modal_content__1mWge","cancel":"modal_cancel__Itv2u","lowPadding":"modal_lowPadding__yi3ZH"};